<template>
    <div>
        <b-container>
            <h3 class="my-4">Registro de Usuarios</h3>
            <b-row align-h="center">
                <b-col cols="12" class="text-centere mb-4">
                    <img src="@/assets/logo.png" alt="">
                </b-col>   
                <b-col cols="3">
                    <form @submit.prevent="crearUsuario(usuario)">
                        <b-form-input type="email" size="sm" placeholder="email" class="my-1"
                                        v-model="usuario.email"></b-form-input>
                        <small class="text-danger d-block" v-if="!$v.usuario.email.required">El email es requerido</small>
                        <small class="text-danger d-block" v-if="!$v.usuario.email.email">Email no valido</small>

                        <b-form-input type="password" size="sm" placeholder="password" class="my-1"
                                        v-model="usuario.pass1"></b-form-input>
                        <small class="text-danger d-block" v-if="!$v.usuario.pass1.required">El password es requerido</small>
                        <small class="text-danger d-block" v-if="!$v.usuario.pass1.minLength">Mínimo 6 caracteres</small>

                        <b-form-input type="password" size="sm" placeholder="repite password" class="my-1"
                                        v-model="usuario.pass2"></b-form-input>
                        <small class="text-danger d-block" v-if="!$v.usuario.pass2.sameAs">Contraseña no coincide</small>

                        <b-button type="submit" variant="info" class="mt-3" size="sm" 
                            :disabled="$v.$invalid">Registrar</b-button>
                    </form>
                    <span class="text-danger font-small" v-if="error === 'auth/email-already-in-use'">El email ingresado ya esta en uso</span>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators';

export default {
    name: 'Registro',
    data() {
        return {
            usuario: {
                email: '',
                pass1: '',
                pass2: ''
            }
        }
    },
    methods: {
        ...mapActions(['crearUsuario'])
    },
    computed: {
        ...mapState(['error']),
        desactivar() {
            return (this.usuario.pass1 === this.usuario.pass2) && (this.usuario.pass1 != '')
        }
    },
    validations: {
        usuario: {
            email: {required, email},
            pass1: {
                required,
                minLength: minLength(6)
            },
            pass2: {
                sameAs: sameAs('pass1')
            }
        }
    }
}
</script>

<style scoped>
    img {
        width: 80px;
    }
    .font-small {
        font-size: 12px;
    }
</style>